import { gql } from "graphql-tag";
import React from "react";
import { useQuery } from "@apollo/client";
import { ServerError } from "components/graphql-views";
import styles from "./step-review-send.module.css";

const GET_TEMPLATE_PREVIEW = gql`
  query TemplatesWithPreview($templateId: ID!, $interestId: ID!) {
    template(id: $templateId) {
      id
      name
      renderedHtml(interestId: $interestId)
    }
  }
`;

type Data = {
  template: {
    id: string;
    name: string;
    renderedHtml: string;
  };
}

type Args = {
  templateId: string;
  interestId: string;
}

type Props = {
  requestedInterestIds: string[];
  templateId: string;
}
const TemplatePreviewItem: React.FC<{templateId: string, interestId: string}> =
({ templateId, interestId }) => {
  const { error, data } = useQuery<Data, Args>(GET_TEMPLATE_PREVIEW, {
    fetchPolicy: "cache-first",
    variables: { templateId, interestId },
  });

  if (error) return <ServerError desc={error.message} />;
  const html: string = data?.template?.renderedHtml || "";

  return (
    <div className={styles.editorContainer} dangerouslySetInnerHTML={{ __html: html }} />
  );
};

const PreviewScroller: React.FC<Props> = (props) => {
  const [index, setIndex] = React.useState(0);
  const { requestedInterestIds } = props;

  const canGoBack = index > 0;
  const canGoForward = index < requestedInterestIds.length - 1;

  return (
    <div className={styles.previewContainer}>
      {canGoBack && (
        <div className={`${styles.prev} fa fa-chevron-left`} onClick={() => setIndex(index - 1)} />
      )}

      {!canGoBack && <div className={styles.btnSpacer} />}

      <TemplatePreviewItem templateId={props.templateId} interestId={requestedInterestIds[index]} />

      {!canGoForward && <div className={styles.btnSpacer} />}

      {canGoForward && (
        <div className={`${styles.next} fa fa-chevron-right`} onClick={() => setIndex(index + 1)} />
      )}
    </div>
  );
};

export default PreviewScroller;
